var constants = require('../constants');
var initialState = require('../../initialState');

var auth = function(state, action) {
    var newstate = Object.assign({}, state);
    switch (action.type) {
        case constants.AUTH_LOGIN_REQUEST:
            newstate.isFetching = true;
            return newstate;
        case constants.AUTH_LOGIN_SUCCESS:
            newstate.isFetching = false;
            newstate.token = action.data.access_token;
            newstate.isAdmin = action.data.isAdmin;
            newstate.error = {};
            return newstate;
        case constants.AUTH_LOGIN_FAILURE:
            newstate.isFetching = false;
            newstate.error = action.errors;
            return newstate;
        case constants.CLEAR_LOGIN_ERROR:
            newstate.error = {};
            return newstate;
        case constants.SET_LOGIN_REDIRECT_URL:
            newstate.loginRedirectUrl = action.loginRedirectUrl;
            return newstate;
        case constants.CLEAR_LOGIN_REDIRECT_URL:
            newstate.loginRedirectUrl = '';
            return newstate;
        case constants.AUTH_REGISTER_SUCCESS:
            newstate.token = action.data.access_token;
            newstate.error = {};
            return newstate;
        case constants.AUTH_REGISTER_ERROR:
            newstate.error = action.errors;
            return newstate;
        case constants.CLEAR_REGISTER_ERROR:
            newstate.error = {};
            return newstate;
        case constants.AUTH_FACEBOOK_REQUEST:
            newstate.isFetching = true;
            return newstate;
        case constants.AUTH_FACEBOOK_SUCCESS:
            newstate.isFetching = false;
            newstate.token = action.data.access_token;
            newstate.error = {};
            return newstate;
        case constants.AUTH_FACEBOOK_FAILURE:
            newstate.isFetching = false;
            newstate.error = action.errors;
            return newstate;
        case constants.REQUEST_CURRENT_USER:
            newstate.isFetching = true;
            return newstate;
        case constants.RECEIVE_CURRENT_USER:
            newstate.isFetching = false;
            newstate.user = action.data.profile;
            newstate.isAdmin = action.data.isAdmin;
            newstate.error = {};
            return newstate;
        case constants.REQUEST_CURRENT_USER_ERROR:
            newstate.isFetching = false;
            newstate.user = {};
            // newstate.error = action.errors; TODO needing a way to decide in which part the error happens, or the error message makes no sense for user at some cases
            return newstate;
        case constants.AUTH_REFRESH_TOKEN_REQUEST:
            newstate.isFetching = true;
            return newstate;
        case constants.AUTH_REFRESH_TOKEN_FAILURE:
            newstate.isFetching = false;
            return newstate;
        default:
            return state || initialState.auth;
    }
}

module.exports = auth;



// WEBPACK FOOTER //
// ./src/common/modules/auth/reducers/auth.js